import { useState, useEffect } from 'react';

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-8 right-8 z-40 w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 animate-in fade-in zoom-in cursor-pointer"
      aria-label="回到顶部"
    >
      <i className="ri-arrow-up-line text-lg w-5 h-5 flex items-center justify-center"></i>
    </button>
  );
}